// extracted by mini-css-extract-plugin
module.exports = {"returnButton":"SignupModal_returnButton__lvyoq","footer":"SignupModal_footer__1Jp8y","loginLink":"SignupModal_loginLink__1oDHU"};